<template>

    <el-tabs type="border-card" style="height:auto">
    <el-tab-pane label="线上订单 > 订单列表" style="height:auto" >
      <el-form :inline="true" :model="order" class="demo-form-inline">
        <el-form-item label="订单编号">
          <el-input size="mini" v-model.trim="order.orderNo" placeholder="订单编号"></el-input>
        </el-form-item>
        <el-form-item label="产品型号">
          <el-input size="mini" v-model.trim="order.manufacturerNumber" placeholder="产品型号"></el-input>
        </el-form-item>
        <el-form-item label="登录用户名">
          <el-input size="mini" v-model.trim="order.moblie" placeholder="登录用户名"></el-input>
        </el-form-item>
        <el-form-item label="关联订单">
          <el-checkbox v-model="order.isBelong"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"  size="mini" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="data"
        size="small"
        :row-class-name="tableRowClassName"
        @cell-dblclick="mainTabClick"
        border>
        <el-table-column 
          fixed
          type="expand" Scoped slot>
          <template slot-scope="props">
            <el-tabs v-model="activeName" @tab-click="handleClick(props.row)" style="width:100%">
              <el-tab-pane label="订单详情" name="first">
                <el-table :data="props.row.childList" 
                :row-class-name="tableRowClassName"
                @cell-dblclick="subTabClick"
                border style="height:100%;">
                  <!-- <el-table-column
                    fixed
                    prop="orderNo"
                    label="子订单编号"
                    width="210">
                  </el-table-column> -->
                  <el-table-column
                    prop="manufacturerNumber"
                    show-overflow-tooltip
                    fixed
                    label="产品型号"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="brandName"
                    show-overflow-tooltip
                    label="品牌"
                    width="110">
                  </el-table-column>
                  <el-table-column
                    prop="originalPrice"
                    show-overflow-tooltip
                    label="商品原单价"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="discountedPrice"
                    show-overflow-tooltip
                    label="购买价格"
                    width="100">
                  </el-table-column>
                  <el-table-column prop="costPrice" label="成本价"
                    width="85"
                    show-overflow-tooltip>
                    <template scope="scope" >
                      <span v-if="(user.isAdmin || (!user.isAdmin && (scope.row.costPrice == 0 || scope.row.costPrice == null))) 
                      && (scope.row.orderStatus>=3 && scope.row.index === cellCost.tabCostIndex && cellCost.tabCostLabel === '成本价')">
                        <el-input size="small"
                        v-model="cellCost.price" placeholder="请输入内容" @blur="handleSubCostEdit(scope.row)"/>
                      </span>
                      <template v-else>
                        <span>{{scope.row.costPrice}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="count"
                    label="购买数量"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="attachAmount"
                    label="附加费"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="preferentialMargins"
                    label="总优惠"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="80">
                    <template slot-scope="scope">
                      <span v-if="scope.row.orderStatus == -4" style="color:#989998">支付失败</span>
                      <span v-if="scope.row.orderStatus == -3" style="color:#989998">已退款</span>
                      <span v-if="scope.row.orderStatus == -2" style="color:#989998">退款申请</span>
                      <span v-if="scope.row.orderStatus == -1" style="color:#989998">已取消</span>
                      <span v-if="scope.row.orderStatus == 0" style="color:#F56C6C">待确认</span>
                      <span v-if="scope.row.orderStatus == 1" style="color:#F56C6C">待付款</span>
                      <span v-if="scope.row.orderStatus == 2" style="color:#67C23A">部分付款</span>
                      <span v-if="scope.row.orderStatus == 21" style="color:#F56C6C">预付订单</span>
                      <span v-if="scope.row.orderStatus == 3" style="color:#67C23A">待审核</span>
                      <span v-if="scope.row.orderStatus == 4" style="color:#67C23A">采购中</span>
                      <span v-if="scope.row.orderStatus == 5" style="color:#67C23A">已采购</span>
                      <span v-if="scope.row.orderStatus == 6" style="color:#409EFF">已发货</span>
                      <span v-if="scope.row.orderStatus == 7" style="color:#F56C6C">已完成</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="originalAmount"
                    label="原总金额"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    prop="totalAmount"
                    label="总金额"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    :formatter="formatStockState"
                    prop="stockState"
                    label="产品来源"
                    width="80">
                  </el-table-column>
                  <el-table-column prop="remark" label="备注"
                    width="180"
                    show-overflow-tooltip>
                    <template scope="scope" >
                      <span v-if="scope.row.index === cellRemark.tabSubIndex && cellRemark.tabSubLabel === '备注'">
                        <el-input size="small"
                        v-model="cellRemark.remark.sub" placeholder="请输入内容" @blur="handleSubRemarkEdit(scope.row)"/>
                      </span>
                      <template v-else>
                        <span>{{scope.row.remark}}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                      <el-popconfirm
                        size="mini"
                        v-if="((scope.row.orderStatus == 3 || scope.row.orderStatus == 4 )) && props.row.childList.length>1"
                        @confirm="removeModifyOrder(scope.row, 4)"
                        title="确定要取消这条记录吗？">
                        <el-button slot="reference"
                        type="danger"
                        size="mini">取消</el-button>
                      </el-popconfirm>
                      <el-button
                        size="mini"
                        v-if="((scope.row.orderStatus == 3 || scope.row.orderStatus == 4) && props.row.isRebating == 0)"
                        @click="showModifyOrder(scope.row, 2)">附加</el-button>
                      <el-button
                        v-if="((scope.row.orderStatus == 3 || scope.row.orderStatus == 4)) && scope.row.totalAmount > 0"
                        size="mini"
                        @click="showModifyOrder(scope.row, 3)">优惠</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="交易记录" name="third">
                <el-table
                  :data="props.row.payRecordList"
                  :row-class-name="tradeRowClassName"
                  style="height:100%;"
                  border>
                  <el-table-column
                    fixed
                    prop="supplementNo"
                    label="支付编号"
                    width="220"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="outPayNo"
                    label="第三方支付编号"
                    width="260"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="payType"
                    :formatter="formatPayType"
                    show-overflow-tooltip
                    label="支付类型"
                    width="80"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="payStatus"
                    label="状态"
                    width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.payStatus == 1" style="color:#F56C6C">待处理</span>
                      <span v-if="scope.row.payStatus == 2" style="color:#67C23A">已完成</span>
                      <span v-if="scope.row.payStatus == 4" style="color:#F56C6C">预付订单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="payMethod"
                    :formatter="formatPay"
                    label="付款方式"
                    width="100"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="payAmount"
                    label="预付金额"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="realAmount"
                    label="已付金额"
                    width="100"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="reason"
                    show-overflow-tooltip
                    label="备注"
                    width="160"
                    >
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="payTime"
                    label="付款时间"
                    width="200"
                    >
                  </el-table-column>
                  <el-table-column
                    label="操作" >
                    <template slot-scope="scope">
                      <el-button v-if="(scope.row.payMethod == 3 && scope.row.payStatus == 1 && (scope.row.payType == 1 || scope.row.payType == 2)) 
                      || (scope.row.payMethod == null && scope.row.payType != 3)"
                        size="mini"
                        @click="confirmPay(scope.row)">确认收款</el-button>
                      <el-popconfirm
                        size="mini"
                        v-if="scope.row.payStatus == 2 && scope.row.realAmount > 0"
                        @confirm="refundModifyOrder(scope.row)"
                        title="确定要取消这条记录吗？">
                        <el-button slot="reference"
                        type="danger"
                        size="mini">退款</el-button>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="收货信息" name="second">
                <el-form ref="addressForm" :model="addressForm" class="invoiceCss">
                  <el-form-item label="收货地址" :label-width="formLabelWidth">
                    <el-input v-model="props.row.receiveAddress"  autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人" :label-width="formLabelWidth">
                    <el-input v-model="props.row.receiveUser"  autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="联系方式" :label-width="formLabelWidth">
                    <el-input v-model="props.row.receiveMobile"  autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item style="margin-left:140px">
                    <el-button type="primary" @click="onSubmitAddress(props.row)">立即保存</el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="发票信息" name="fourth">
                <template v-if="props.row.userInvoiceResponseVo">
                  <el-form>
                    <el-form-item label="发票类型" :label-width="formLabelWidth">
                    <el-select v-model="props.row.userInvoiceResponseVo.type" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="发票抬头" :label-width="formLabelWidth"> 
                      <el-input v-model="props.row.userInvoiceResponseVo.companyName"  autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="税务登记号" :label-width="formLabelWidth">
                      <el-input v-model="props.row.userInvoiceResponseVo.invoiceNumber" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" :label-width="formLabelWidth">
                      <el-input v-model="props.row.userInvoiceResponseVo.email" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="公司注册地址" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.companyAddress" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="公司电话" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.companyMobile" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.bankName" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行账号" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.bankNumber" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="收票人" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.consignee" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="收票地址" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.addressDetail" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-input v-model="props.row.userInvoiceResponseVo.mobile" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="电子版盖章开票信息" :label-width="formLabelWidth" v-show="props.row.userInvoiceResponseVo.type == 2">
                      <el-image :src="props.row.userInvoiceResponseVo.invoiceFile" ></el-image>
                    </el-form-item>
                  </el-form>
                </template>
                <template v-else>
                  <div style="padding: 10px 0 20px 0; width: 60%; text-align:center;">
                    暂无
                  </div>
                </template>
              </el-tab-pane>
              <el-tab-pane label="合同记录" name="five">
                <template v-if="props.row.contractRecordList">
                  <el-table
                    :data="props.row.contractRecordList"
                    border
                    style="width: 75%">
                    <el-table-column
                      prop="contractNo"
                      show-overflow-tooltip
                      label="合同编号">
                    </el-table-column>
                    <el-table-column
                      prop="consignee"
                      show-overflow-tooltip
                      label="合同下载">
                      <template slot-scope="scope">
                        <a target="_blank" :href="scope.row.contractPath">查看</a>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="createDate"
                      show-overflow-tooltip
                      label="合同时间">
                    </el-table-column>
                  </el-table>
                </template>
                <template v-else>
                  <div v-if="(props.row.orderStatus != 7 || props.row.orderStatus != 8) 
                      && props.row.invoiceId && props.row.userInvoiceResponseVo && props.row.userInvoiceResponseVo.type == 2"  
                      class="invoice-css">
                    <el-button
                      size="mini"
                      @click="createContract(props.row)">合同</el-button>
                  </div>
                  <div class="invoice-css" v-else>
                    当前数据无法生成合同
                  </div>
                </template>
              </el-tab-pane>
              <el-tab-pane label="历史订单记录" name="six">
                <el-table :data="historyData" border style="height:100%;">
                  <el-table-column
                    fixed
                    prop="orderNo"
                    label="子订单编号"
                    width="210">
                  </el-table-column>
                  <el-table-column
                    prop="manufacturerNumber"
                    show-overflow-tooltip
                    label="产品型号"
                    width="160">
                  </el-table-column>
                  <el-table-column
                    prop="brandName"
                    show-overflow-tooltip
                    label="品牌"
                    width="110">
                  </el-table-column>
                  <el-table-column
                    prop="originalPrice"
                    show-overflow-tooltip
                    label="商品原单价"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="discountedPrice"
                    show-overflow-tooltip
                    label="购买价格"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="count"
                    label="购买数量"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="sendCount"
                    label="发货数量"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="attachAmount"
                    label="附加费"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="preferentialMargins"
                    label="总优惠"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="80">
                    <template slot-scope="scope">
                      <span v-if="scope.row.orderStatus == -4" style="color:#989998">支付失败</span>
                      <span v-if="scope.row.orderStatus == -3" style="color:#989998">已退款</span>
                      <span v-if="scope.row.orderStatus == -2" style="color:#989998">退款申请</span>
                      <span v-if="scope.row.orderStatus == -1" style="color:#989998">已取消</span>
                      <span v-if="scope.row.orderStatus == 0" style="color:#F56C6C">待确认</span>
                      <span v-if="scope.row.orderStatus == 1" style="color:#F56C6C">待付款</span>
                      <span v-if="scope.row.orderStatus == 2" style="color:#67C23A">部分付款</span>
                      <span v-if="scope.row.orderStatus == 21" style="color:#F56C6C">预付订单</span>
                      <span v-if="scope.row.orderStatus == 3" style="color:#E6A23C">待审核</span>
                      <span v-if="scope.row.orderStatus == 4" style="color:#67C23A">采购中</span>
                      <span v-if="scope.row.orderStatus == 5" style="color:#67C23A">已采购</span>
                      <span v-if="scope.row.orderStatus == 6" style="color:#409EFF">已发货</span>
                      <span v-if="scope.row.orderStatus == 7" style="color:#F56C6C">已完成</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="originalAmount"
                    label="原总金额"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    prop="totalAmount"
                    label="总金额"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    prop="remark"
                    label="备注">
                  </el-table-column>
                </el-table>
                <pagination :pagination="hisPagination" v-on:paginationClick="queryHistoryPagination"></pagination>
              </el-tab-pane>
            </el-tabs>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="orderNo"
          label="订单编号"
          show-overflow-tooltip
          width="220">
        </el-table-column>
        <el-table-column
          fixed
          prop="createDate"
          show-overflow-tooltip
          label="下单时间"
          width="160">
        </el-table-column>
        <el-table-column
          label="登录用户"
          show-overflow-tooltip
          width="114">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.orderStatus != -1 && scope.row.orderStatus != -3"
              placement="top"
              title="收货信息"
              trigger="click">
              <p>登录名: {{ scope.row.userName }}</p>
              <p>收货人: {{ scope.row.receiveUser }}</p>
              <p>联系方式: {{ scope.row.receiveMobile }}</p>
              <p>收货地址: {{ scope.row.receiveAddress }}</p>
              <el-button type="text" slot="reference">{{ scope.row.userName }}</el-button>
            </el-popover>
            <span v-else>{{ scope.row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="用户名"
          prop="receiveUser"
          show-overflow-tooltip
          width="80">
        </el-table-column>
        <el-table-column
          prop="originalAmount"
          label="商品总金额"
          width="100">
        </el-table-column>
        <el-table-column
          prop="transportAmount"
          label="运费"
          width="60">
        </el-table-column>
        <el-table-column
          prop="attachAmount"
          label="附加费"
          width="100">
        </el-table-column>
        <el-table-column
          prop="rebateAmount"
          label="退还金额"
          width="100">
        </el-table-column>
        <el-table-column
          prop="preferentialMargins"
          label="总优惠"
          width="100">
        </el-table-column>
        <el-table-column
          prop="totalAmount"
          label="订单金额"
          width="100">
        </el-table-column>
        <el-table-column
          prop="payAmount"
          label="实收款"
          width="100">
        </el-table-column>
        <el-table-column
          label="状态"
          width="90">
          <template slot-scope="scope">
            <span v-if="scope.row.orderStatus == -4" style="color:#989998"><el-tag type="danger">支付失败</el-tag></span>
            <span v-if="scope.row.orderStatus == -3" style="color:#989998"><el-tag type="info">已退款</el-tag></span>
            <span v-if="scope.row.orderStatus == -2" style="color:#989998"><el-tag type="danger">退款申请</el-tag></span>
            <span v-if="scope.row.orderStatus == -1" style="color:#989998"><el-tag type="info">已取消</el-tag></span>
            <span v-if="scope.row.orderStatus == 0" style="color:#F56C6C"><el-tag type="danger">待确认</el-tag></span>
            <span v-if="scope.row.orderStatus == 1" style="color:#F56C6C"><el-tag type="danger">待付款</el-tag></span>
            <span v-if="scope.row.orderStatus == 2" style="color:#E6A23C"><el-tag type="warning">部分付款</el-tag></span>
            <span v-if="scope.row.orderStatus == 21" style="color:#F56C6C"><el-tag type="warning">预付订单</el-tag></span>
            <span v-if="scope.row.orderStatus == 3" style="color:#67C23A">
              <el-tooltip class="item" effect="dark" content="部分退款申请，请及时处理" placement="top-start" v-if="scope.row.isRebating == 1">
                <el-tag type="danger">预处理</el-tag>
              </el-tooltip>
              <span v-else>
                <el-tag type="success">待审核</el-tag>
              </span>
            </span>
            <span v-if="scope.row.orderStatus == 4" style="color:#67C23A">
              <el-tooltip class="item" effect="dark" content="部分退款申请，请及时处理" placement="top-start" v-if="scope.row.isRebating == 1">
                <el-tag type="danger">预处理</el-tag>
              </el-tooltip>
              <span v-else>
                <el-tag type="warning">待发货</el-tag>
              </span>
            </span>
            <span v-if="scope.row.orderStatus == 5" style="color:#67C23A">
              <el-tooltip class="item" effect="dark" content="部分退款申请，请及时处理" placement="top-start" v-if="scope.row.isRebating == 1">
                <el-tag type="danger">预处理</el-tag>
              </el-tooltip>
              <span v-else>
                <el-tag type="success">发货中</el-tag>
              </span>
            </span>
            <span v-if="scope.row.orderStatus == 6" style="color:#409EFF"><el-tag>已发货</el-tag></span>
            <span v-if="scope.row.orderStatus == 7" style="color:#F56C6C"><el-tag type="info">已完成</el-tag></span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"
          show-overflow-tooltip>
          <template scope="scope" >
            <span v-if="scope.row.index === cellRemark.tabMainIndex && cellRemark.tabMainLabel === '备注'">
              <el-input size="small"
               v-model="cellRemark.remark.main" placeholder="请输入内容" @blur="handleRemarkEdit(scope.row)"/>
            </span>
            <template v-else>
              <span>{{scope.row.remark}}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="80">
          <template slot-scope="scope">
            <el-button
            v-if="scope.row.orderStatus == 3 && scope.row.isRebating == 0"
              size="mini"
              @click="auditTo(scope.row)">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
    <el-dialog :title="title" :visible.sync="dialogOrderFormVisible" width="780px">
      <el-form :model="invoiceParam">
        <el-form-item label="主订单编号" :label-width="formLabelWidth">
          <el-input v-model="modifyOrderForm.orderNo" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="订单编号" :label-width="formLabelWidth">
          <el-input v-model="modifyOrderForm.subOrderNo" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="产品价格" :label-width="formLabelWidth">
          <el-input v-model="modifyOrderForm.price" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="产品数量" :label-width="formLabelWidth">
          <el-input v-model="modifyOrderForm.count" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="editorMehotd == 1" @click="modifySubmitOrder">确定</el-button>
        <el-button v-if="editorMehotd == 2" @click="modifyAttachAmountOrder">确定</el-button>
        <el-button v-if="editorMehotd == 3" @click="modifyRebateAmountOrder">确定</el-button>
        <el-button @click="dialogOrderFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
   </el-tabs>

   
</template>
<script>
import pagination from "../../common/util/pagination";

export default {
  data() {
    return {
      data: [],
      optionItem: {},
      historyData: [],
      editorMehotd: 1,
      title: '',
      cellRemark: {
        tabMainIndex : '',
        tabMainLabel : '',
        tabSubIndex : '',
        tabSubLabel : '',
        remark: {
          main: '',
          sub: ''
        },
      },
      addressForm: {
        token: this.user.getToken(),
        orderNo: "",
        receiveAddress: "",
        receiveUser:"",
        receiveMobile: ""
      },
      cellCost: {
        tabCostIndex : '',
        tabCostLabel : '',
        price: 0
      },
      formLabelWidth: '140px',
      dialogFormVisible:false,
      dialogOrderFormVisible: false,
      discountedPrice: 0,
      activeName: 'first',
      addressList: [],
      payList:[],
      historyOrder: {
        userId: '',
        token: this.user.getToken()
      },
      order: {
        payType: '',
        orderNo: '',
        isBelong: false,
        orderStatus:'2',
        token: this.user.getToken()
      },
      contract: {
        orderNo: '',
        token: this.user.getToken()
      },
      modifyOrderForm: {
        orderNo: '',
        subOrderNo: '',
        count: 0,
        price: 0,
        token: this.user.getToken()
      },
      invoiceParam: {
      },
      hisPagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      },
      orderNos: '',
      options: [{
          value: 1,
          label: '普通发票'
        }, {
          value: 2,
          label: '专用发票'
        }, {
          value: 3,
          label: '个人'
        }]
    };
  },
  components: {
    pagination
  },
  methods: {
    mainTabClick: function(row, column, cell, event) {
      this.cellRemark.tabMainIndex = row.index
      this.cellRemark.tabMainLabel = column.label
      this.cellRemark.remark.main = row.remark
    },
    subTabClick: function(row, column, cell, event) {
      if (column.label == '备注') {
        this.cellRemark.tabSubIndex = row.index
        this.cellRemark.tabSubLabel = column.label
        this.cellRemark.remark.sub = row.remark
      }else if (column.label == '成本价') {
        this.cellCost.tabCostIndex = row.index
        this.cellCost.tabCostLabel = column.label
        this.cellCost.price= row.costPrice
      }
    },
    // 退款申请
    refundModifyOrder: function(row) {
      // 判断该订单下是否存在需要发货的字订单
      this.http.post(
      '/order/refund/apply', 
      {
        supplementNo: row.supplementNo,
        payType: row.payType,
        token: this.user.getToken()
      }, res => {
        if (res.success) {
          // 返回正确的处理
          this.getOrderData();
        } else {
          // 返回错误的处理
          this.$message.error(res.message)
        }
      });
    },
    modifySubmitOrder: function() {
      this.http.post(
        '/order/modify/subclass',
        this.modifyOrderForm,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.getOrderData();
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      })
      this.dialogOrderFormVisible = false
    },
    // 附加费
    modifyAttachAmountOrder: function() {
      console.log(this.discountedPrice, this.modifyOrderForm.price)
      if (this.modifyOrderForm.price >= this.discountedPrice) {
        this.http.post(
        '/order/attach/amount',
        this.modifyOrderForm,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.getOrderData();
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        })
        this.dialogOrderFormVisible = false
      } else {
        this.$message.error('附加费用，商品单价必须大于等于原单价！')
      }
    },
    modifyRebateAmountOrder: function() {
      if (this.modifyOrderForm.price <= this.discountedPrice) {
        this.http.post('/order/rebate/amount',
        this.modifyOrderForm,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.getOrderData();
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        })
        this.dialogOrderFormVisible = false
      } else {
        this.$message.error('退还/优惠退还，商品单价必须小于等于原单价！')
      }
    },
    handleClick(sval) {
      if (this.activeName =='six') {
        this.historyOrder.userId = sval.userId
        this.getHistoryOrderData()
      }
    },
    showModifyOrder: function(rows, val) {
      this.discountedPrice = rows.discountedPrice
      if (val == 2) {
        this.title = '附加费'
      }else if (val == 3) {
        this.title = '优惠退还'
      }
        this.editorMehotd = val
        // 编辑订单
        this.dialogOrderFormVisible = true
        this.modifyOrderForm.orderNo = rows.mainOrderNo
        this.modifyOrderForm.subOrderNo = rows.orderNo
        this.modifyOrderForm.count = rows.count
        this.modifyOrderForm.price = rows.discountedPrice
    },
    removeModifyOrder: function(rows) {
        // 判断该订单下是否存在需要发货的字订单
      this.http.post('/order/sub/cancel', 
        {
          orderNo: rows.mainOrderNo,
          subOrderNo: rows.orderNo,
          token: this.user.getToken()
        }, res => {
          if (res.success) {
            // 返回正确的处理
            this.getOrderData();
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    confirmPay: function(rows) {
        // 判断该订单下是否存在需要发货的字订单
      this.$prompt('是否确认付款了该笔交易订单', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          this.http.post(
            '/confirmPay/apply',
            {
              orderNo: rows.orderNo,
              payAmount: value,
              token: this.user.getToken()
            }, res => {
              if (res.success) {
                // 返回正确的处理
                this.getOrderData();
              } else {
                // 返回错误的处理
                this.$message.error(res.message)
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
      });
    },
    createContract: function(rows) {
      this.contract.orderNo = rows.orderNo
      // 初始化默认加载菜单
      this.http.post(
        '/contract/create',
        this.contract,
        res => {
          if (res.success) {
            this.getOrderData()
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    handleSelectionChange: function(rows) {
      this.orderNos = ''
      rows.forEach((item) => {
        this.orderNos += item.orderNo + ','
      })
    },
    tableRowClassName({row, rowIndex}) {
      row.index = rowIndex
    },
    formatPay: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "微信";
      } else if (cellValue === 2) {
        return "支付宝";
      } else if (cellValue === 3) {
        return "对公付款";
      }
    },
    formatPayType: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "付款";
      } else if (cellValue === 2) {
        return "附加费";
      } else if (cellValue === 3) {
        return "退还";
      } else if (cellValue === 3) {
        return "取消";
      }
    },
    formatStockState: function(row, column, cellValue) {
      if (cellValue === 0) {
        return "digikey";
      } else if (cellValue === 10) {
        return "京北通宇";
      } else if (cellValue === 8) {
        return "国内现货";
      } else if (cellValue === 4) {
        return "云汉商城";
      } else if (cellValue === 5) {
        return "华强商城";
      } else if (cellValue === 6) {
        return "维样商城";
      } else if(cellValue === 2) {
        return "自营库存";
      } else if(cellValue === -1) {
        return "mouser";
      } else if(cellValue === -2) {
        return "arrow";
      } else if(cellValue === 11) {
        return "圣禾堂";
      } else if(cellValue === 3) {
        return "立创商城";
      }else{
        return "其他";
      }
    },
    formatPayStatus: function(row, column, cellValue) {
      if (cellValue === 1) {
        return "未付款";
      } else if (cellValue === 2) {
        return "已付款";
      } else if (cellValue === 3) {
        return "失败";
      } else if (cellValue === 4) {
        return "部分付款";
      }
    },
    tradeRowClassName({row, rowIndex}) {
      row.index = rowIndex
      if (row.payAmount === 0) {
        return 'del_line efficacy-row'
      }
      return '';
    },
    formatMobile: function(row, column, cellValue) {
      if (cellValue) {
        return cellValue.mobile;
      }
    },
    getHistoryOrderData: function() {
      this.optionItem = this.common.extend(this.historyOrder, this.hisPagination);
      // 初始化默认加载菜单
      this.http.post(
        '/order/history/list',
        this.optionItem,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.historyData = res.datas.data;
            this.hisPagination.pageSize = res.datas.page.pageSize
            this.hisPagination.pageNum = res.datas.page.pageNum
            this.hisPagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    getOrderData: function() {
      this.optionItem = this.common.extend(this.order, this.pagination);
      // 初始化默认加载菜单
      this.http.post(
        '/order/list',
        this.optionItem,
        res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data;
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        }
      );
    },
    auditTo: function(row) {
      // 判断该订单下是否存在需要发货的字订单
      this.$confirm('是否审核该订单信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.http.post(
          '/order/audit',
          {
            orderNo: row.orderNo,
            token: this.user.getToken()
          }, res => {
            if (res.success) {
              // 返回正确的处理
              this.getOrderData();
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消审核'
        });          
      });
    },
    onSubmit: function() {
      this.pagination.pageNum = 1
      this.getOrderData()
    },
    queryHistoryPagination: function(currPage) {
      this.hisPagination.pageNum = currPage
      this.getHistoryOrderData()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getOrderData()
    },
    handleSubCostEdit: function(row) {
      if (this.cellCost.price < 0) {
        this.$message.error('成本必须大于0')
        return
      }
      if (this.cellCost.price != row.costPrice) {
        this.http.post(
          '/order/detail/set/costprice', 
          {
            orderNo: row.orderNo,
            costPrice: this.cellCost.price,
            token: this.user.getToken()
          }, res => {
            if (res.success) {
              row.costPrice = this.cellCost.price
              this.cellCost.tabCostIndex = null
              this.cellCost.tabCostLabel = '' 
              this.cellCost.price = ''
              // 返回正确的处理
              // this.getOrderData();
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
        });
      }else {
        this.cellCost.tabCostIndex = null
        this.cellCost.tabCostLabel = '' 
        this.cellCost.price = ''
      }
    },
    handleSubRemarkEdit: function(row) {
      if (this.cellRemark.remark.sub != row.remark) {
        this.http.post(
          '/order/detail/remark/subset',
          {
            orderNo: row.orderNo,
            remark: this.cellRemark.remark.sub,
            token: this.user.getToken()
          }, res => {
            if (res.success) {
              row.remark = this.cellRemark.remark.sub
              this.cellRemark.tabSubIndex = null
              this.cellRemark.tabSubLabel = '' 
              this.cellRemark.remark.sub = ''
              // 返回正确的处理
              // this.getOrderData();
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
        });
      }else {
        this.cellRemark.tabSubIndex = null
        this.cellRemark.tabSubLabel = '' 
        this.cellRemark.remark.sub = ''
      }
    },
    handleRemarkEdit: function(row) {
      if (this.cellRemark.remark.main != row.remark) {
        this.http.post(
          '/order/remark/set',
          {
            orderNo: row.orderNo,
            remark: this.cellRemark.remark.main,
            token: this.user.getToken()
          }, res => {
            if (res.success) {
              this.cellRemark.tabMainIndex = null
              this.cellRemark.tabMainLabel = '' 
              this.cellRemark.remark.main = '' 
              // 返回正确的处理
              this.getOrderData();
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
          });
      }else {
        this.cellRemark.tabMainIndex = null
        this.cellRemark.tabClickLabel = '' 
        this.cellRemark.remark.main = row.remark
      }
    },
    onSubmitAddress: function(row) {
      this.addressForm.orderNo = row.orderNo
      this.addressForm.receiveAddress = row.receiveAddress
      this.addressForm.receiveUser = row.receiveUser
      this.addressForm.receiveMobile = row.receiveMobile
      this.http.post('/order/address/modify', this.addressForm, res => {
          if (res.success) {
            // 返回正确的处理
            this.getOrderData();
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    }
  },
  mounted: function() {
    this.getOrderData();
  },
};
</script>


<style>
.invoice-css {
  padding: 10px 0 20px 0; width: 60%; text-align:center;
}
.el-table th {
  background: #F5F7FA;
}
.el-table__expanded-cell {  
  padding: 0px 0px 15px 47px !important;
}
.el-tabs {
  border:1px solid #eee;
}
.el-tabs__nav {
  padding: 0 20px;
}
.el-tabs__active-bar {
  margin-left: 20px;
}
.el-input--suffix .el-input__inner {
  padding-right: 16px;
}

.demo-table-expand {
  font-size: 0;
}
.el-form-item__content {
  line-height: none;
}
.el-table .warning-row {
  background: oldlace;
}
.el-table .remind-row {
  background: rgb(253, 246, 236) !important;
}
.el-table .success-row {
  background: #f0f9eb;
}
.el-table .success-refund{
  background: #FFF;
}
.el-table .success-paid{
  background:#FFF;
}
.el-table .success-over {
  background: #f5f7fa;
}
.el-button+.el-button {
    margin-left: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/views/order/orderPendingAuditList.vue